var map = {
	"./Case_Havelaar_1000x1430_1.png": 88991,
	"./Case_Havelaar_1000x1430_2.png": 34340,
	"./Case_Havelaar_1000x1430_3.png": 74285,
	"./Case_Havelaar_1000x1430_4.png": 18130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25250;